<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Class Note Setup</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.classNoteModal" modal-classes="modal-dialog-centered modal-lg">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="row">
                                                <div class="col-md-12 pb-2">
                                                    <div class="row">
                                                        <div class="col">
                                                            <img v-if="ImagePathval" :src="ImagePathval"
                                                                class="img-fluid" />
                                                            <img v-else src="/img/brand/empty.png" class="img-fluid" />
                                                        </div>
                                                        <div class="col">
                                                            <ImageUploader @emitOutImgPathval="UpdateImagePathval" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Class Note Description</label>
                                                        <vue-editor id="ClassNoteDescriptionval"
                                                            v-model="ClassNoteDescriptionval">
                                                        </vue-editor>

                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Class Note</label>
                                                        <vue-editor id="ClassNoteval" v-model="ClassNoteval">
                                                        </vue-editor>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">
                                    <base-button type="default" @click="modals.classNoteModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="SubmitClassNote()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <select v-model="SchoolTypeIdval" class="form-control"
                                        @change="GetSchoolsForPortal()" 
                                        :disabled="SchoolTypeItems === null">
                                        <option value="0">{{ SchoolTypeItems === null ? '⏳ Loading...' : '- Select School Type-'
                                            }}</option>                                      
                                        <option v-for="item in SchoolTypeItems" :key="item.schoolTypeId"
                                            v-bind:value="item.schoolTypeId">
                                            {{ item.schoolTypeName }}
                                        </option>
                                    </select>
                                    <select v-model="SchoolIdval" class="form-control ml-2" @change="GetSchoolLevels()"
                                    :disabled="SchoolItems === null">
                                        <option value="0">{{ SchoolItems === null ? '⏳ Loading...' : '- Select School -'
                                            }}</option>    
                                        <option v-for="item in SchoolItems" :key="item.schoolId"
                                            v-bind:value="item.schoolId">
                                            {{ item.schoolName }}
                                        </option>
                                    </select>
                                    <select v-model="SchoolLevelIdval" class="form-control ml-2"
                                        @change="GetSchoolSubjects()"
                                        :disabled="SchoolLevelItems === null">
                                        <option value="0">{{ SchoolLevelItems === null ? '⏳ Loading...' : '- Select Level -'
                                            }}</option>
                                        <option v-for="item in SchoolLevelItems" :key="item.schoolLevelId"
                                            v-bind:value="item.schoolLevelId">
                                            {{ item.schoolLevelName }}
                                        </option>
                                    </select>
                                    <select v-model="SchoolSubjectIdval" class="form-control ml-2"
                                        @change="GetClassNotes()"
                                       :disabled="SchoolSubjectItems === null">
                                        <option value="0">{{ SchoolSubjectItems === null ? '⏳ Loading...' : '- Select Subject -'
                                            }}</option>    
                                        <option v-for="item in SchoolSubjectItems" :key="item.schoolSubjectId"
                                            v-bind:value="item.schoolSubjectId">
                                            {{ item.schoolSubjectName }}
                                        </option>
                                    </select>
                                </div>
                                <div class="justify-content-end form-inline">
                                    <button class="btn btn-success mr-3" v-on:click="OpenNewClassNoteModal()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <div v-if="ClassNoteItems">
                                    <div v-for="item in ClassNoteItems" :key="item.classNoteId">
                                        <div class="card mt-2">
                                            <div class="card-body bg-secondary">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <img :src="item.imagePath
                                                                " class="card-img-top" alt="...">
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <h5 class="card-title" v-html="item.classNote"></h5>
                                                            <div class="card-text" v-html="item.classNoteDescription">
                                                            </div>
                                                            <div class="card-footer text-center">
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="GetById(item)">
                                                                    <i class="fa fa-edit"></i> Edit
                                                                </button>
                                                                <!-- <button class="btn btn-danger btn-sm"
                                                                    v-on:click="GetById(item.classNoteId)">
                                                                    <i class="fa fa-times"></i> Delete
                                                                </button> -->
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="OpenClassNoteLesson(item.classNoteId)">
                                                                    <i class="fa fa-eye"></i> View Lessons
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>


import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import { VueEditor } from 'vue2-quill-editor'
import ImageUploader from "@/components/ImageUploader"
import katex from 'katex';
import 'katex/dist/katex.min.css';
window.katex = katex;

export default {
    name: "questionheader",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        ImageUploader,
        VueEditor
    },
    data() {
        return {
            accessDetails: null,
            ClassNoteIdval: 0,
            ClassNoteval: "",
            ClassNoteDescriptionval: "",
            SchoolSubjectIdval: 0,
            SchoolTypeIdval: 0,
            SchoolLevelIdval: 0,
            SchoolIdval: 0,
            ImagePathval: null,
            searchValueval: "All",
            SchoolLevelItems: null,
            SchoolSubjectItems: null,
            SchoolTypeItems: null,
            SchoolItems: null,
            ClassNoteItems: null,
            isModified: false,
            onloader: "none",
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                classNoteModal: false
            }
        };
    },
    methods: {
        OpenNewClassNoteModal() {
            this.isModified = false;
            this.modals.classNoteModal = true
        },
        resetInput() {
            this.ClassNoteval = "";
            this.ClassNoteDescriptionval = "";
            this.ImagePathval = null;
        },
        OpenClassNoteLesson(Id) {
            localStorage.setItem("ClassNoteId", Id);
            this.$router.push("/admin/eduschool/class-note-lesson-setup");
        },
        GetById(item) {
            this.resetInput();
            this.ClassNoteIdval = item.classNoteId;
            this.ClassNoteval = item.classNote;
            this.ClassNoteDescriptionval = item.classNoteDescription;
            this.ImagePathval = item.imagePath;
            this.isModified = true;
            this.modals.classNoteModal = true;
        },
        SubmitClassNote() {
            let ClassNoteId = this.ClassNoteIdval;
            let ClassNote = this.ClassNoteval;
            let ClassNoteDescription = this.ClassNoteDescriptionval;
            let SchoolSubjectId = this.SchoolSubjectIdval;
            let ImagePath = this.ImagePathval;
            if (SchoolSubjectId > 0) {
                let userdata = {};
                this.onloader = "flex";
                let operationVal = "";
                if (this.isModified == false) {
                    operationVal = "ClassNote/CreateClassNote";
                    userdata = {
                        ClassNote,
                        ClassNoteDescription,
                        SchoolSubjectId,
                        ImagePath,
                    }
                } else {
                    operationVal = "ClassNote/UpdateClassNote";
                    userdata = {
                        ClassNoteId,
                        ClassNote,
                        ClassNoteDescription,
                        SchoolSubjectId,
                        ImagePath,
                    }
                }              
                this.$store
                    .dispatch(operationVal, userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetClassNotes();
                            this.resetInput();
                            this.modals.classNoteModal = false;
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.ShowAlertError('Select Subject', '');
            }

        },
        UpdateImagePathval(data) {
            this.ImagePathval = data;
        },
        GetSchoolTypeForPortal() {
            this.onloader = "flex";
            this.$store
                .dispatch("SchoolType/GetSchoolTypeForPortal")
                .then((resp) => {
                    this.SchoolTypeItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetSchoolsForPortal() {
            let SchoolTypeId = this.SchoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("School/GetSchoolsForPortal", SchoolTypeId)
                    .then((resp) => {
                        this.SchoolItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetSchoolLevels() {
            let SchoolTypeId = this.SchoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolTypeId
                }
                this.$store
                    .dispatch("SchoolLevel/GetSchoolLevels", userData)
                    .then((resp) => {
                        this.SchoolLevelItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetSchoolSubjects() {
            let SchoolId = this.SchoolIdval;
            let SchoolLevelId = this.SchoolLevelIdval;
            if (SchoolLevelId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolId,
                    SchoolLevelId
                }
                this.$store
                    .dispatch("SchoolSubject/GetSchoolSubjects", userData)
                    .then((resp) => {
                        this.SchoolSubjectItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetClassNotes() {
            let SchoolSubjectId = this.SchoolSubjectIdval;
            if (SchoolSubjectId > 0) {
                this.onloader = "flex";
                const userData = {
                    SchoolSubjectId
                }

                this.$store
                    .dispatch("ClassNote/GetClassNotes", userData)
                    .then((resp) => {
                        this.ClassNoteItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.ClassNoteItems.filter((item) => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            (v) =>
                                item.classNote.toLowerCase().includes(v) ||
                                item.classNoteDescription.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.ClassNoteItems;
            }
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetSchoolTypeForPortal();
        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>